"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_broadband__or__wifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cb1b9eec-bd10-48ba-b277-8fccfc8ba5ad",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 115"
  }, props), /*#__PURE__*/React.createElement("title", null, "broadband-device"), /*#__PURE__*/React.createElement("path", {
    id: "d2eeb0db-0e7b-4997-b253-d4dbdfbecef9",
    "data-name": "<Pfad>",
    d: "M20,59.5a107.43,107.43,0,0,1,152,0",
    transform: "translate(-16 -24)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "46abbf4c-5393-4637-82a8-b7fcfeee5be7",
    "data-name": "<Pfad>",
    d: "M42,82.51a76.76,76.76,0,0,1,108.6,0",
    transform: "translate(-16 -24)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "170a9dd3-a259-4bc1-986f-2a110f171523",
    "data-name": "<Pfad>",
    d: "M64.6,105.08a44.62,44.62,0,0,1,63.12,0",
    transform: "translate(-16 -24)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 107,
    r: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 107,
    r: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 107,
    r: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = ic_broadband__or__wifi;
exports.default = _default;